import { useSyncExternalStore } from 'react';
import {
  getSelectedCity,
  setSelectedCity,
  subscribeSelectedCity,
} from './city-store';

export function useSelectedCity(): [string, (code: string) => void] {
  const code = useSyncExternalStore(
    subscribeSelectedCity,
    getSelectedCity,
    getSelectedCity,
  );
  return [code, setSelectedCity];
}
